import { render, staticRenderFns } from "./proofWXService.vue?vue&type=template&id=0c12fb2c&"
import script from "./proofWXService.vue?vue&type=script&lang=js&"
export * from "./proofWXService.vue?vue&type=script&lang=js&"
import style0 from "./proofWXService.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports